import Vue from 'vue'
import store from '@/store'
import {
  LANGUAGE
} from '@/store/mutation-types'

export default function Initializer () {
  const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'
  store.dispatch('SetLang', lang.replace(/-/, '_'))

  // document.domain = 'eccang.com'
}
